import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';

class ResetPasswordConnectErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      errorInfo: null,
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    if (this.state.errorInfo) {
      return (<Navigate to={{
        pathname: '/',
        state: {
          errorInfo: this.state.errorInfo,
        },
      }}
      />);
    }

    return this.props.children;
  }
}

export default ResetPasswordConnectErrorBoundary;
